import { render, staticRenderFns } from "./Transporter.vue?vue&type=template&id=2409af64&scoped=true&"
import script from "./Transporter.vue?vue&type=script&lang=js&"
export * from "./Transporter.vue?vue&type=script&lang=js&"
import style0 from "./Transporter.vue?vue&type=style&index=0&id=2409af64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409af64",
  null
  
)

export default component.exports